import React, { useState } from "react";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import axiosInstant from "../../api";
import { salesLeadsCsvEndpoint } from "../../api/endpoints";
import ExportFieldsModal, { ExportField } from "../../components/ExportFieldsModal/ExportFieldsModal";

const FIELDS: ExportField[] = [
    { label: "Lead ID", value: "id" },
    { label: "Email", value: "email" },
    { label: "First Name", value: "first_name" },
    { label: "Last Name", value: "last_name" },
    { label: "Source", value: "source" },
    { label: "Subscribed", value: "subscribed" },
    { label: "Created Date", value: "created_at" },
    { label: "Updated Date", value: "updated_at" },
    { label: "Account", value: "account" },
    { label: "Brand", value: "brand" },
    { label: "Plan", value: "plan" },
];

interface Props {
    open: boolean;
    onClose: () => void;
    search?: string;
}

export default function DownloadLeadsCsv({ open, onClose, search }: Props) {
    const [loading, setLoading] = useState(false);

    const downloadLeads = async (selected: ExportField[]) => {
        setLoading(true);
        try {
            const params: Record<string, string> = {
                selectedFields: JSON.stringify(selected),
            };
            if (search) params.search = search;
            const res = await axiosInstant.get(salesLeadsCsvEndpoint, { params, responseType: "blob" });
            const url = URL.createObjectURL(res.data as Blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `leads-${dayjs().format("YYYY-MM-DD")}.csv`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
            toast.success("CSV downloaded");
            onClose();
        } catch {
            toast.error("Unable to download. Kindly try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <ExportFieldsModal
            open={open}
            onClose={onClose}
            fields={FIELDS}
            loading={loading}
            onExport={downloadLeads}
        />
    );
}
